
<BasicConfigurator :value="imagesForBasicConfigurator"
                   :product="product"
                   :configuration-valid="configurationValid"
                   @addedToBasket="addedToBasket"
                   @error="onError"
                   @reset="resetConfiguration">
  <v-stepper v-model="step" vertical :non-linear="true" class="configurationStepper">
    <v-stepper-step v-if="personSelectionNeeded"
                    :complete="step > personSelectionStep"
                    :step="personSelectionStep"
                    edit-icon="check"
                    editable
    >Code auswählen
      <small>Von welcher Person möchten Sie alle Fotos auswählen?</small>
    </v-stepper-step>
    <v-stepper-content v-if="personSelectionNeeded" :step="personSelectionStep">
      <PersonSelector v-model="personIndex" :persons="eligiblePersons" @select="onPersonSelect"/>
    </v-stepper-content>

    <v-stepper-step
        :complete="step > imageSelectionStep"
        :step="imageSelectionStep"
        edit-icon="check"
    >Vorschau
    </v-stepper-step>
    <v-stepper-content :step="imageSelectionStep" class="imageStepperContent">
      <ImageSelector :value="selectedImages"
                     :images="selectedImages"
                     :select-all="true"
                     :filter="filter"
                     :scrollable-container-parent-layers="1"
                     ref="imageSelector"
      />
    </v-stepper-content>
  </v-stepper>
</BasicConfigurator>
